import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';

import { useLocalization } from 'redux/localization/utils/hooks';

const Error404 = () => {
  const { t } = useLocalization();
  const settings = useSelector((state) => state.setting.data);
  const { companyName } = settings;

  return (
    <>
      <Helmet>
        <title>
          {t('general.errorMessages.pageNotFoundTitle')}|| {companyName}
        </title>
      </Helmet>
      <section className="c7-content c7-error-page">
        <div className="c7-wrapper">
          <h1 className="c7-h1">
            {' '}
            {t('general.errorMessages.pageNotFoundTitle')}
          </h1>
          <p>{t('general.errorMessages.pageNotFoundMessage')}</p>
          <a
            href={settings.continueShopping}
            className="c7-btn c7-btn--primary"
          >
            {t('checkout.general.continueShopping')}
          </a>
        </div>
      </section>
    </>
  );
};

export default Error404;
